import React, { createContext, useContext, useState, useEffect } from "react";
import { GetAxios } from "../helpers/axiosHelpers";

const SiteInfoContext = createContext({ infoMap: {}, loaded: false });

/**
 * Fetches /information/public once at app level and shares it with all
 * descendant components via context — avoids redundant network requests.
 */
export const SiteInfoProvider = ({ children }) => {
  const [infoMap, setInfoMap] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    GetAxios("/information/public")
      .then((res) => {
        if (res?.success && Array.isArray(res.data)) {
          const m = {};
          res.data.forEach((item) => {
            m[item.key] = item.value;
          });
          setInfoMap(m);
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <SiteInfoContext.Provider value={{ infoMap, loaded }}>
      {children}
    </SiteInfoContext.Provider>
  );
};

/**
 * Returns { info, loaded }
 *   info(key, fallback?) — returns backend value when available, else fallback
 *   loaded              — true once the API call has settled
 */
export const useSiteInfo = () => {
  const { infoMap, loaded } = useContext(SiteInfoContext);
  const info = (key, fallback = "") => infoMap[key] ?? fallback;
  return { info, loaded };
};
